const WORDS = [
  "Pizza",
  "Birra",
  "Smash Burger",
  "Ø 42 cm",
  "Sottile & Digeribile",
  "Villagana",
];

export const Marquee = () => {
  const sequence = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee"
      className="marquee-wrap relative border-y border-[var(--line)] py-6 md:py-8 overflow-hidden select-none"
    >
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center shrink-0">
            {sequence.map((w, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="font-serif text-3xl md:text-5xl px-6 md:px-10 whitespace-nowrap">
                  {w}
                </span>
                <span className="text-[var(--fg-dim)] text-2xl md:text-4xl">—</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
